import type { RadioStation } from '@/mocks/radios';

interface RadioBadgesProps {
  station: RadioStation;
}

interface BadgeConfig {
  key: string;
  label: string;
  icon: string;
  show: boolean;
  colorClass: string;
}

export default function RadioBadges({ station }: RadioBadgesProps) {
  const isOficial = station.id === 0 || station.category === 'Oficial';
  const isVerificada = station.isPremium;
  const isStreamingExterno = station.hostingType === 'external';
  const isStreamingRfw = station.hostingType === 'rfw_hosting';
  const isFrecuenciaPremium = station.isPremium;
  const isFrecuenciaEstandar = !station.isPremium;

  const badges: BadgeConfig[] = [
    {
      key: 'oficial',
      label: 'Oficial RFW',
      icon: 'ri-vip-crown-fill',
      show: isOficial,
      colorClass: 'bg-amber-100 text-amber-800 border border-amber-300/70',
    },
    {
      key: 'verificada',
      label: 'Verificada',
      icon: 'ri-verified-badge-fill',
      show: isVerificada,
      colorClass: 'bg-emerald-100 text-emerald-800 border border-emerald-300/70',
    },
    {
      key: 'streaming-externo',
      label: 'Streaming Externo',
      icon: 'ri-cloud-line',
      show: isStreamingExterno,
      colorClass: 'bg-foreground-100 text-foreground-600 border border-foreground-300/60',
    },
    {
      key: 'streaming-rfw',
      label: 'Streaming RFW',
      icon: 'ri-broadcast-line',
      show: isStreamingRfw,
      colorClass: 'bg-accent-100 text-accent-700 border border-accent-300/70',
    },
    {
      key: 'frecuencia-premium',
      label: 'Frecuencia Premium',
      icon: 'ri-star-fill',
      show: isFrecuenciaPremium,
      colorClass: 'bg-amber-100 text-amber-800 border border-amber-300/70',
    },
    {
      key: 'frecuencia-estandar',
      label: 'Frecuencia Estándar',
      icon: 'ri-star-line',
      show: isFrecuenciaEstandar,
      colorClass: 'bg-background-100 text-foreground-500 border border-background-300/60',
    },
  ];

  const visibleBadges = badges.filter((b) => b.show);

  if (visibleBadges.length === 0) return null;

  return (
    <div className="flex items-center gap-1.5 flex-wrap">
      {visibleBadges.map((badge) => (
        <span
          key={badge.key}
          className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-semibold whitespace-nowrap ${badge.colorClass}`}
        >
          <i className={`${badge.icon} text-xs`}></i>
          {badge.label}
        </span>
      ))}
    </div>
  );
}